<template>
    <div>

    </div>
</template>

<script>
    import log from "utils/log"
    import {setToken} from "utils/auth"
    import apiHomePage from "@/api/home-page/index"

    export default {
        props: {},
        computed: {},
        data() {
            return {}
        },
        methods: {
            getParams() {
                let s = location.search
                let list = s.slice(1).split('&')
                let code = list[0]
                let state = list[1]
                if (code && state) {
                    return {
                        wxCode: code.split('=')[1],
                        state: state.split('=')[1],
                    }
                }
                return {
                    wxCode: '123456',
                    state: 'abcd',
                }
                // return null
            },
        },
        created() {
            let param = this.getParams()
            if (param) {
                apiHomePage.getToken(param).then(res => {
                    // 存储 res data
                    let token = res.data
                    setToken(token)
                    this.$router.push({
                        name: 'home'
                    })
                })
            }
        },
        mounted() {
        }

    }
</script>

<style lang='scss' scoped>

</style>
